import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '../../@fuse/shared.module';

import { AuthGuardService } from '../guards/auth-guard.service';

import { DashboardComponent } from './dashboard/dashboard.component';
import {MatCardModule, MatIconModule} from '@angular/material';
import {NgxLoadingModule} from 'ngx-loading';
import {FlexModule} from '@angular/flex-layout';
import {PusherService} from '../shared/services/pusher.service';
import {BarChartModule, PieChartModule} from '@swimlane/ngx-charts';
import { UsersTypeChartComponent } from './dashboard/users-type-chart/users-type-chart.component';
import { JobsByTypeChartComponent } from './dashboard/jobs-by-type-chart/jobs-by-type-chart.component';
import { JobsEvolutionsMonthChartComponent } from './dashboard/jobs-evolutions-month-chart/jobs-evolutions-month-chart.component';
import { JobsByCityChartComponent } from './dashboard/jobs-by-city-chart/jobs-by-city-chart.component';

const routes = [
    {
        path     : 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
    },

];

@NgModule({
  declarations: [DashboardComponent, UsersTypeChartComponent, JobsByTypeChartComponent, JobsEvolutionsMonthChartComponent, JobsByCityChartComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatCardModule,
        NgxLoadingModule,
        MatIconModule,
        FlexModule,
        PieChartModule,
        BarChartModule,
    ],
  providers: [AuthGuardService, PusherService],
})
export class HomeModule {

}
